export default __webpack_public_path__ + "static/media/icon-twitter.52eba3e1.svg";